import React from "react";

const AppProvider = ({ children }) => <>{children}</>;

export default AppProvider;
